import { type ComponentProps } from 'react'

import { InputSelectCurrent } from '../InputSelectCurrent/InputSelectCurrent'
import { InputWithLabel } from '../InputWithLabel/InputWithLabel'

import styles from './InputSelectWithLabel.module.scss'

type Props = {
  label: string
  variant?: ComponentProps<typeof InputWithLabel>['variant']
} & ComponentProps<typeof InputSelectCurrent>

export const InputSelectWithLabel = ({ label, variant, ...props }: Props) => (
  <InputWithLabel label={label} variant={variant}>
    <span className={styles.field}>
      <InputSelectCurrent {...props} />
    </span>
  </InputWithLabel>
)
